/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import styles from '../../styles';

const Wrapper = styled.div`
`;

const Table = styled.table`
  width: 100%;
`;

const HeaderRow = styled.tr`
  height: 2rem;
  background-color: #54698D;
`;

const ColumnHeader = styled.tr`
  height: 2rem;
  background-color: #E6ECF2;
`;


const HeaderCell = styled.th`
  padding-left: 1rem;
  @media (max-width: 767px) {
    &:first-child {
      padding-left: 1.25rem;
    }
  }

  ${styles.fonts.headingLabelCaps}

  align-items: center;
  text-transform: uppercase;

  width: ${(p) => p.sizeLarge/12*100}%;
  display ${(p) => p.hideLarge ? 'none' : 'table-cell'};

  @media (max-width: 1023px) {
    width: ${(p) => p.sizeMedium/12*100}%;
    display ${(p) => p.hideMedium ? 'none' : 'table-cell'};
  }

  @media (max-width: 767px) {
    width: ${(p) => p.sizeSmall/12*100}%;
    display ${(p) => p.hideSmall? 'none' : 'table-cell'};
  }
`;

const HeaderCellWhiteText = styled(HeaderCell)`
  color: white;
`;


const DataRow = styled.tr`
  width: 100%;
  &:hover {
    background-color: #F0F8FC;
  }
`;

const DataCell = styled.td`
  width: 33%;
  padding-left: 1rem;
  @media (max-width: 767px) {
    &:first-child {
      padding-left: 1.25rem;
    }
  }

  height: 2.5rem;
  vertical-align: middle;
  font-size: 13px;
  color: #16325C;

  border-top: 1px solid #D8DDE6;

  display ${(p) => p.hideLarge ? 'none' : 'table-cell'};

  @media (max-width: 1023px) {
    display ${(p) => p.hideMedium ? 'none' : 'table-cell'};
  }

  @media (max-width: 767px) {
    display ${(p) => p.hideSmall? 'none' : 'table-cell'};
  }
`;

const DataTable = ({ rows, columns, className, children, showColumns, noneText }) => (
  <Wrapper className={className}>
    <Table>
      <thead>
        { showColumns &&
          <ColumnHeader>
            { columns.map((column, i) => (
              <HeaderCell
                id='date'
                scope='col'
                key={i}
                sizeLarge={column.sizeLarge}
                sizeMedium={column.sizeMedium}
                sizeSmall={column.sizeSmall}
                hideSmall={column.hideSmall}
                hideMedium={column.hideMedium}
                hideLarge={column.hideLarge}
              >
                {column.title}
              </HeaderCell>
            ))}
          </ColumnHeader> }
        { children && <HeaderRow><HeaderCellWhiteText>{ children }</HeaderCellWhiteText><HeaderCell/><HeaderCell/></HeaderRow>}
      </thead>
      <tbody>
        { (!rows || !rows.length) ?
            <DataRow><DataCell>{ noneText }</DataCell></DataRow> :
            rows.map((row, i) => (
            <DataRow key={i}>
              {columns.map((column, ii) => (
                <DataCell
                  key={i + '_' + ii}
                  hideSmall={column.hideSmall}
                  hideMedium={column.hideMedium}
                  hideLarge={column.hideLarge}
                >
                  { column.render ? column.render(row) : row[column.name] }
                </DataCell>
              ))}
            </DataRow>
          ))
        }
      </tbody>
    </Table>
  </Wrapper>
);

export default DataTable;
